import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import { Icons } from "assets";
import CustomButton from "shared/components/common/customButton";

interface BlogDetails {
  title: string;
  category: string;
  cover_url: string;
  content: string;
  created_at: string;
}

interface Props extends ModalProps {
  blogDetails: BlogDetails;
  handleSubmit?: () => void;
  actionButtonText?: string;
  loading?: boolean;
  title?: string;
}

const ViewBlogModal = ({
  title,
  blogDetails,
  actionButtonText,
  loading,
  show,
  handleClose,
  handleSubmit,
}: Props) => {
  const contentDetails = [
    { label: "Title", value: blogDetails.title },
    { label: "Category", value: blogDetails.category },
    { label: "Creation Date", value: blogDetails.created_at.slice(0, 10) },
    { label: "Content", isHTML: true, value: blogDetails.content },
  ];

  return show ? (
    <CustomModal onClose={handleClose}>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames(
            "flex items-center justify-between px-4 mt-4 mb-3"
          )}
        >
          <h3 className={(styles.modalTitle, "font-bold")}>
            {title ? title : "Blog Details"}
          </h3>
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              if (!loading) {
                handleClose();
              }
            }}
          >
            <Icons.Cross />
          </div>
        </div>

        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-6")}
        >
          <div className={classNames(styles.blogDetails)}>
            <div
              className={classNames(
                styles.customerDetails,
                "grid grid-cols-12 gap-1"
              )}
            >
              {contentDetails.map((data) => (
                <>
                  <p className={classNames(styles.contentItem, "col-span-3")}>
                    <strong>{data.label} :</strong>
                  </p>
                  {data.isHTML ? (
                    <div
                      className="col-span-9"
                      dangerouslySetInnerHTML={{ __html: data.value }}
                    />
                  ) : (
                    <h6 className="col-span-9">{data.value}</h6>
                  )}
                </>
              ))}
            </div>

            {blogDetails?.cover_url ? (
              <div
                className={classNames(
                  styles.coverImageContainer,
                  "flex flex-col items-start gap-1.5 mt-2"
                )}
              >
                <p className={classNames(styles.contentItem)}>
                  <strong>Cover Image:</strong>
                </p>
                <img
                  src={blogDetails.cover_url}
                  alt="Blog Cover"
                  className={classNames(styles.coverImage)}
                />
              </div>
            ) : (
              <h6>Image not uploaded</h6>
            )}
          </div>

          <div
            className={classNames(
              "flex items-center w-full justify-center gap-4"
            )}
          >
            {handleSubmit && (
              <CustomButton
                title={actionButtonText ? actionButtonText : "Proceed"}
                containerStyle={classNames(styles.actionButton, "px-12")}
                onClick={handleSubmit}
                loading={loading}
                disabled={loading}
              />
            )}
          </div>
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default ViewBlogModal;
